import React, { useState, useEffect, Suspense } from "react";
// import ReactDOM from "react-dom";
import Modal from "react-modal";
import Main from "./pages/Main.js";
import { withTranslation, useTranslation } from "react-i18next";
import "./App.css";

function App({
  containerId,
  resolve,
  reject,
  type,
  devmode,
  modal,
  tsId,
  authTokenStream,
  email,
  firstName,
  lastName,
  lang,
  name,
}) {
  Modal.setAppElement("#" + containerId);
  const urlParams = new URLSearchParams(window.location.search);
  const [loaded, setLoaded] = useState(false);
  if (!type) {
    type = urlParams.get("type");
  }
  if (!devmode) {
    devmode = urlParams.get("devmode") === "1";
  }
  const [authToken, setAuthToken] = useState(null);

  // Subscribe to authTokenStream to get token updates
  useEffect(() => {
    if (authTokenStream) {
      const subscription = authTokenStream.subscribe((token) => {
        setAuthToken(token);
      });
      
      return () => subscription.unsubscribe();
    }
  }, [authTokenStream]);

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  // }

  // function closeModal() {
  //   resolve("CANCELLED");
  //   ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  // }

  const { i18n } = useTranslation("common");

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);
  return (
    <div id="ops-booking-form">
      <Suspense fallback="loading">
        <div className={`App ${loaded ? "loaded" : ""}`}>
          <header className="App-header">
            <Main
              type={type}
              resolve={resolve}
              reject={reject}
              devmode={devmode}
              modal={modal}
              tsId={tsId}
              authToken={authToken}
              email={email}
              firstName={firstName}
              lastName={lastName}
              setLoaded={setLoaded}
              name={name}
              lang={lang}
            />
          </header>
        </div>
      </Suspense>
    </div>
  );
}

export default withTranslation()(App);
